module.exports = __webpack_public_path__ + "static/media/4.aace9192.jpg";